import React from 'react';

import { DateTime } from 'luxon';

import { Nullable } from '@clearverify/types';

import { EmployerInfoFragment, PeoInfoFragment, VerifierType } from 'src/api';
import { DEFAULT_END_DATE, DEFAULT_START_DATE, NOW } from 'src/constants/dashboard';

export type DashboardCVAdminContextValue = {
  date: DateTime<true>;

  setDate: React.Dispatch<React.SetStateAction<DashboardCVAdminContextValue['date']>>;

  employers: EmployerInfoFragment[] | undefined;
  setEmployers: React.Dispatch<React.SetStateAction<DashboardCVAdminContextValue['employers']>>;

  peos: PeoInfoFragment[] | undefined;
  setPeos: React.Dispatch<React.SetStateAction<DashboardCVAdminContextValue['peos']>>;

  usageReportStartDate: Nullable<DateTime>;
  usageReportEndDate: Nullable<DateTime>;
  workLetterUsageStartDate: Nullable<DateTime>;
  workLetterUsageEndDate: Nullable<DateTime>;

  revenueByVerificationTypeStartDate: Nullable<DateTime>;
  revenueByVerificationTypeEndDate: Nullable<DateTime>;
  revenueDistributionsStartDate: Nullable<DateTime>;
  revenueDistributionsEndDate: Nullable<DateTime>;

  verifierType: VerifierType;

  setVerifierType: React.Dispatch<
    React.SetStateAction<DashboardCVAdminContextValue['verifierType']>
  >;
  setUsageReportStartDate: React.Dispatch<
    React.SetStateAction<DashboardCVAdminContextValue['usageReportStartDate']>
  >;
  setUsageReportEndDate: React.Dispatch<
    React.SetStateAction<DashboardCVAdminContextValue['usageReportEndDate']>
  >;
  setRevenueByVerificationTypeStartDate: React.Dispatch<
    React.SetStateAction<DashboardCVAdminContextValue['revenueByVerificationTypeStartDate']>
  >;
  setRevenueByVerificationTypeEndDate: React.Dispatch<
    React.SetStateAction<DashboardCVAdminContextValue['revenueByVerificationTypeEndDate']>
  >;
  setRevenueDistributionsStartDate: React.Dispatch<
    React.SetStateAction<DashboardCVAdminContextValue['revenueDistributionsStartDate']>
  >;
  setRevenueDistributionsEndDate: React.Dispatch<
    React.SetStateAction<DashboardCVAdminContextValue['revenueDistributionsEndDate']>
  >;
  setWorkLetterUsageStartDate: React.Dispatch<
    React.SetStateAction<DashboardCVAdminContextValue['workLetterUsageStartDate']>
  >;
  setWorkLetterUsageEndDate: React.Dispatch<
    React.SetStateAction<DashboardCVAdminContextValue['workLetterUsageEndDate']>
  >;
};

export const DEFAULT_DASHBOARD_CV_ADMIN_CONTEXT: DashboardCVAdminContextValue = {
  date: NOW,
  setDate: () => {},

  employers: [],
  setEmployers: () => {},

  peos: [],
  setPeos: () => {},

  workLetterUsageStartDate: DEFAULT_START_DATE,
  setWorkLetterUsageStartDate: () => {},

  workLetterUsageEndDate: DEFAULT_END_DATE,
  setWorkLetterUsageEndDate: () => {},

  usageReportStartDate: DEFAULT_START_DATE,
  setUsageReportStartDate: () => {},

  usageReportEndDate: DEFAULT_END_DATE,
  setUsageReportEndDate: () => {},

  revenueByVerificationTypeStartDate: DEFAULT_START_DATE,
  setRevenueByVerificationTypeStartDate: () => {},

  revenueByVerificationTypeEndDate: DEFAULT_END_DATE,
  setRevenueByVerificationTypeEndDate: () => {},

  revenueDistributionsStartDate: DEFAULT_START_DATE,
  setRevenueDistributionsStartDate: () => {},

  revenueDistributionsEndDate: DEFAULT_END_DATE,
  setRevenueDistributionsEndDate: () => {},

  verifierType: VerifierType.Commercial,
  setVerifierType: () => {},
};

export const DashboardCVAdminContext = React.createContext(DEFAULT_DASHBOARD_CV_ADMIN_CONTEXT);
